import { render, staticRenderFns } from "./BaseCollapse.vue?vue&type=template&id=08d48a11"
import script from "./BaseCollapse.vue?vue&type=script&lang=js"
export * from "./BaseCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports